// For some reason, React is required even tho not used? Wtf?
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import Router from './components/SPA/Router';
if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: "https://5ad85a7f892c4dc99325ae6da2f84c1a@o201630.ingest.sentry.io/5460633",
        integrations: [
            new Integrations.BrowserTracing(),
        ],
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 1.0,
    });
}
// We only want to try to render our component on pages that have a div with an ID
// of "example"; otherwise, we will see an error in our console
if (document.getElementById('spa')) {
    ReactDOM.render(React.createElement(Router, null), document.getElementById('spa'));
}
